import { Component, OnInit, inject } from '@angular/core';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CdsLangService, CdsLanguageModule } from '@cds/ng-core/lang';

import { MatDialogRef } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';

@Component({
  selector: 'app-user-confirm-pop',
  templateUrl: './user-confirm-pop.component.html',
  styleUrls: ['./user-confirm-pop.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class UserConfirmPopComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<UserConfirmPopComponent>>(MatDialogRef);
  cdsLangService = inject(CdsLangService);

  agreeButtonConfig: CdsButtonConfig = {
    size: 'sm',
    style: 'secondary',
    disabled: false,
  };
  disagreeButtonConfig: CdsButtonConfig = {
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  ngOnInit(): void {}
  agree() {
    this.dialogRef.close({ agree: true });
  }
  disagree() {
    this.dialogRef.close({ agree: false });
  }
}
